import $ from 'jquery'
import JsAlert from 'js-alert'

const main = () => {

    // products Swiper
    if(document.getElementById('page-home') === null) return
    const productsSwiper = new Swiper(".products-swiper", {
        speed: 900, 
        loop: true, 
        watchSlidesProgress: true,
        autoplay: {
        delay: 3000, 
        }
    })

    // case Swiper
    const caseSwiper = new Swiper(".case-swiper", {
        speed: 900, 
        loop: true, 
        watchSlidesProgress: true,
        autoplay: {
        delay: 3000, 
        },
        slidesPerView: 1.9,
        centeredSlides : true,
        spaceBetween: 30,
        breakpoints: {
            480: {
                slidesPerView: 1.8,
                spaceBetween: 70,
            },
            751: {
                slidesPerView: 2,
                spaceBetween: 35,
            },
            1050: {
                slidesPerView: 3,
                spaceBetween: 35,
            }
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'progressbar',
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        }
    })

    // case モーダル表示
    $(function(){
        $('.modal-open').each(function(){
            $(this).on('click',function(){
                var target = $(this).data('target');
                var modal = document.getElementById(target);
                $(modal).fadeIn();
                return false;
            });
        });
        $('.js-modal-close').on('click',function(){
            $('.js-modal').fadeOut();
            return false;
        }); 
    });
}

export default main